import {
  DndContext,
  DragEndEvent,
  DragOverlay,
  DragStartEvent,
  MouseSensor,
  pointerWithin,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import React, { ReactNode, useCallback, useState } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: ReactNode;
  onDragEnd: (event: DragEndEvent) => void;
};

export const ImageGalleryDndContext = ({ children, onDragEnd }: Props) => {
  const [dragOverlay, setDragOverlay] = useState<null | ReactNode>(null);
  const sensors = useSensors(useSensor(MouseSensor, { activationConstraint: { distance: 5 } }));
  const handleDragStart = ({ active }: DragStartEvent) => {
    return setDragOverlay(active.data.current?.dragOverlay);
  };

  const reset = useCallback(() => {
    setDragOverlay(null);
  }, []);

  const handleImageDrop = useCallback(
    (event: DragEndEvent) => {
      reset();
      onDragEnd(event);
    },
    [reset, onDragEnd],
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={pointerWithin}
      onDragStart={handleDragStart}
      onDragEnd={handleImageDrop}
      onDragCancel={reset}
    >
      {children}
      {createPortal(
        <DragOverlay>
          <div>{dragOverlay}</div>
        </DragOverlay>,
        document.body,
      )}
    </DndContext>
  );
};
